export const c_progress_stepper_m_vertical__step_connector_before_Left = {
  "name": "--pf-c-progress-stepper--m-vertical__step-connector--before--Left",
  "value": "calc(1.75rem / 2)",
  "var": "var(--pf-c-progress-stepper--m-vertical__step-connector--before--Left)"
};
export default c_progress_stepper_m_vertical__step_connector_before_Left;